function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "m115.2 29.375h-102.4a1.75 1.75 0 0 0 -1.75 1.75v65.75a1.75 1.75 0 0 0 1.75 1.75h102.4a1.751 1.751 0 0 0 1.75-1.75v-65.75a1.751 1.751 0 0 0 -1.75-1.75zm-1.75 3.5v9.625h-98.9v-9.625zm-98.9 62.25v-49.125h98.9v49.125z"
}), React.createElement("path", {
  d: "m74.75 59.125h23a1.75 1.75 0 0 0 0-3.5h-23a1.75 1.75 0 0 0 0 3.5z"
}), React.createElement("path", {
  d: "m104.25 68.75h-29.5a1.75 1.75 0 0 0 0 3.5h29.5a1.75 1.75 0 0 0 0-3.5z"
}), React.createElement("path", {
  d: "m104.25 81.875h-29.5a1.75 1.75 0 0 0 0 3.5h29.5a1.75 1.75 0 0 0 0-3.5z"
}), React.createElement("path", {
  d: "m48.736 67.75a10.917 10.917 0 1 0 -13.222 0 18.391 18.391 0 0 0 -11.764 17.125v3.375a1.751 1.751 0 0 0 1.75 1.75h33.25a1.751 1.751 0 0 0 1.75-1.75v-3.375a18.391 18.391 0 0 0 -11.764-17.125zm-14.028-8.667a7.417 7.417 0 1 1 7.417 7.417 7.426 7.426 0 0 1 -7.417-7.417zm22.292 27.417h-29.75v-1.625a14.875 14.875 0 0 1 29.75 0z"
}));

var SvgLicense = function SvgLicense(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLicense, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/license.8b99b407.svg";
export { ForwardRef as ReactComponent };